import {
    Box,
    Container,
    Grid,
    Skeleton,
    ThemeProvider,
    Typography,
    createTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import {
    GetFinancialSuppliersForCreditRequestResponse,
} from "../../models/report.model";
import {
    GetFinancialSuppliersForCreditRequest,
} from "../../services/report.service";
import useUUID from "../../hook/useUUID";
import FacilityPlansCmp from "../../components/cards/facilityPlansCmp";
import { getLoanTemplateSummary } from "../../services/loanTemplate.service";
import { GetLoanTemplateSummaryResponse, LoanTemplateIdRequest } from "../../models/loanTemplate.model";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1350,
            xl: 1536,
        },
    },
});

const FinancialSupplierDetailList = (logo: any) => {

    const history = useHistory<any>();
    const [facilityPlanData, setFacilityPlanData] = useState<GetLoanTemplateSummaryResponse[]>();
    const [financialSuppliersOption, setFinancialSuppliersOption] = useState<
        GetFinancialSuppliersForCreditRequestResponse[]
    >([]);


    const id = localStorage.getItem("Supplier_ID");
    // history.location.state !== undefined ? history.location.state.id : null;


    const { mutate: getLoanTemplateSummaryMutation, isLoading } = useMutation(getLoanTemplateSummary, {
        onSuccess: (data: GetLoanTemplateSummaryResponse[]) => {
            if (data) {
                setFacilityPlanData(data);
            }
        },
        onError: () => { },
    });



    // const getLoanTemplateSummaryMutation = useMutation(getLoanTemplateSummary, {
    //     onSuccess: (data: GetLoanTemplateSummaryResponse[]) => {
    //         if (data) {
    //             setFacilityPlanData(data);
    //         }
    //     },
    //     onError: () => { },
    // });

    const { mutate: getFinancialSuppliersForCreditRequest } = useMutation(
        GetFinancialSuppliersForCreditRequest,
        {
            onSuccess: (data: GetFinancialSuppliersForCreditRequestResponse[]) => {
                if (data) {
                    setFinancialSuppliersOption(data);
                }
            },
            onError: () => { },
        }
    );


    useEffect(() => {
        getFinancialSuppliersForCreditRequest({ supplierId: Number(id) });
    }, [getFinancialSuppliersForCreditRequest, id]);

    useEffect(() => {
        let loanTemplateId = {} as LoanTemplateIdRequest;
        loanTemplateId.id = Number(id);
        getLoanTemplateSummaryMutation(loanTemplateId);
    }, [id]);


    useEffect(() => {

        if (history.action === "POP") {

            history.push({
                pathname: "/FinancialSupplier1/FinancialSupplierDetailList"
            });
        }
    }, [history, id]);


    const supplierKeys = useUUID(facilityPlanData?.length);
    const logoSupplier = window.sessionStorage.getItem('logoSupplier');
    const titleSupplier = window.sessionStorage.getItem('titleSupplier');
    return (
        <>
            <ThemeProvider theme={theme}>
                <div>
                    {/* supplier card detail info */}
                    <Grid container marginBottom={"4rem"}>
                        <Grid item xs={12}>

                            <Box
                                sx={{
                                    backgroundColor: "rgba(154,175,196,0.15)",
                                    borderRadius: "5px",
                                }}
                                paddingY={"1rem"}
                            >
                                <Grid container justifyContent={"center"} alignItems={"center"}>
                                    <Grid item xs={2} md={2} sm={4} style={{ position: 'relative', maxWidth: 'fit-content' }}>
                                        {logoSupplier ?
                                            <div className="suppliersCardImg" style={{
                                                justifyContent: 'center',
                                                display: 'flex', alignContent: 'center', flexWrap: 'wrap'
                                            }}>
                                                <img
                                                    // style={{ height: '21px', width: '55px' }}
                                                    style={{
                                                        width: '-webkit-fill-available',
                                                        height: 'auto',
                                                        maxWidth: '80%'
                                                    }}
                                                    className="activePlansCardImg"
                                                    src={`data:image/png;base64,${logoSupplier}`}
                                                    alt=""
                                                />
                                            </div>
                                            :
                                            <div className="suppliersCardImg"></div>
                                        }
                                    </Grid>
                                    <Grid item xs={4} md={4} sm={6}>
                                        {titleSupplier ?
                                            <span style={{ color: '#1D4A87', fontSize: '16px', fontWeight: 'bold' }}>
                                                {titleSupplier}
                                            </span>
                                            : ""}
                                    </Grid>
                                    <Grid item xs={6} md={6} sm={2}></Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Active Plans Detail */}
                    {
                        <div className="suppliersListDetailContent">
                            <span className="financialListDetailTitle">
                                طرح‌های تسهیلاتی
                            </span>
                            {isLoading ?
                                (
                                    <Grid container spacing={0} style={{ paddingTop: '20px' }}>
                                        <Grid xs={12} sm={12} md={2} lg={2} textAlign={"right"}>
                                            <Skeleton
                                                variant="rectangular"
                                                width={140}
                                                height={75}
                                                animation='wave'
                                                sx={{
                                                    borderRadius: "5px",
                                                }}
                                            ></Skeleton>
                                        </Grid>
                                        <Grid container spacing={0} xs={9} sm={12} md={9} lg={9}>
                                            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid
                                                    container
                                                    alignItems={"center"}
                                                    justifyContent={{
                                                        xs: "center",
                                                        sm: "center",
                                                        md: "center",
                                                        lg: "space-between",
                                                    }}
                                                >
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Skeleton
                                                            variant="rectangular"
                                                            width={240}
                                                            height={20}
                                                            animation='wave'
                                                            sx={{
                                                                // marginLeft: "0.5rem",
                                                                borderRadius: "5px",
                                                            }}
                                                        ></Skeleton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                container
                                                xs={12}
                                                columns={{ xs: 4, sm: 8, md: 12 }}
                                                style={{ alignSelf: 'center' }}
                                            >
                                                <Grid
                                                    item
                                                    xs={6}
                                                    md={3}
                                                    sm={6}
                                                    borderLeft={{ lg: "1px solid #c1c7cb", md: "1px solid #c1c7cb" }}
                                                    borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                                                    paddingX={".5rem"}
                                                    paddingY={{
                                                        xs: "1rem",
                                                        sm: "1rem",
                                                        md: "1rem",
                                                        lg: "0",
                                                        xl: "0",
                                                    }}
                                                >
                                                    <Skeleton
                                                        variant="rectangular"
                                                        width={140}
                                                        height={20}
                                                        animation='wave'
                                                        sx={{
                                                            borderRadius: "5px",
                                                        }}
                                                    ></Skeleton>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={4}
                                                    md={4}
                                                    sm={6}
                                                    borderLeft={{ lg: "1px solid #c1c7cb", md: "1px solid #c1c7cb" }}
                                                    borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                                                    paddingX={{ lg: ".5rem", md: "0" }}
                                                    paddingY={{
                                                        xs: "1rem",
                                                        sm: "1rem",
                                                        md: "1rem",
                                                        lg: "0",
                                                        xl: "0",
                                                    }}
                                                >
                                                    <Skeleton
                                                        variant="rectangular"
                                                        width={140}
                                                        height={20}
                                                        animation='wave'
                                                        sx={{
                                                            borderRadius: "5px",
                                                        }}
                                                    ></Skeleton>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={3}
                                                    md={3}
                                                    sm={6}
                                                    paddingX={".5rem"}
                                                    paddingY={{
                                                        xs: "1rem",
                                                        sm: "1rem",
                                                        md: "1rem",
                                                        lg: "0",
                                                        xl: "0",
                                                    }}
                                                >
                                                    <Skeleton
                                                        variant="rectangular"
                                                        width={140}
                                                        height={20}
                                                        animation='wave'
                                                        sx={{
                                                            borderRadius: "5px",
                                                        }}
                                                    ></Skeleton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ) : null
                            }

                            {facilityPlanData?.length === 0 ? (
                                <Typography padding={"5rem"} textAlign={"center"}>
                                    طرح تسهیلاتی فعالی وجود ندارد
                                </Typography>
                            ) : (
                                facilityPlanData?.map((supplier: any, index: any) => (
                                    <Grid

                                        style={{ cursor: 'pointer' }}
                                        key={supplierKeys[index]}
                                        className="ActivePlansCardContainer"
                                        onClick={() => {
                                            history.push({
                                                pathname: "/FinancialSupplier1/FinancialSupplierDetailList1/FinancialSupplierDetail",
                                                state: { id: supplier.id },
                                            });
                                            localStorage.setItem(
                                                "FinancialSupplier_ID",
                                                JSON.stringify(supplier.loanTemplateId)
                                            );
                                        }}
                                    >
                                        <FacilityPlansCmp {...supplier} />
                                    </Grid>
                                ))
                            )}
                        </div>
                    }
                </div>
            </ThemeProvider>
        </>
    );
};

export default FinancialSupplierDetailList;
